import React from "react";
import { Helmet } from 'react-helmet-async';
import Section from "./Section";
import { Container } from "reactstrap";
import DashboardContent from "./DashboardContent";
import CreditPanel from "./CreditPanel";
import { useEffect } from "react";
import DashboardDesign from "./DashboardDesign";

const ManageJobApplications = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard | Webvi </title>
      </Helmet>
      <Section />
      <section className='section'>
        <Container>
          <DashboardDesign />
          {/* <CreditPanel /> */}
          
          <DashboardContent />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageJobApplications;
